import { createRouter, createWebHistory } from "vue-router";
import Signin from "../views/Signin.vue";
import Signup from "../views/Signup.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import PasswordReset from "../views/PasswordReset.vue";
import Home from "../views/Home.vue";
import OfferList from "../views/offers/OfferList.vue";
import PlanSaleList from "../views/plan_sales/PlanSaleList.vue";
import PlanSaleDetails from "../views/plan_sales/PlanSaleDetails.vue";
import AnalyticsRetail from "../views/analytics/Retail.vue";
import OrganizationList from "../views/merchants/OrganizationList.vue";
import StoreList from "../views/merchants/StoreList.vue";
import StoreDetails from "../views/merchants/StoreDetails.vue";
import UserList from "../views/merchants/UserList.vue";
import InsurerManagerList from "../views/internal/InsurerManagerList.vue";
import InsurerManagerShow from "../views/internal/InsurerManagerShow.vue";
import store from "../store";
import { NotFound } from "@estaly/ui";

const publicRoutes = [
  {
    path: "/signin",
    component: Signin,
  },

  {
    path: "/signup",
    component: Signup,
  },

  {
    path: "/forgot-password",
    component: ForgotPassword,
  },

  {
    path: "/password-reset/:id",
    component: PasswordReset,
  },

  {
    path: "/404",
    component: NotFound,
  },
];

const insurerRoutes = [
  {
    path: "/home",
    component: Home,
    meta: { layout: "insurer-layout" },
  },

  {
    path: "/offers",
    component: OfferList,
    meta: { layout: "insurer-layout" },
  },

  {
    path: "/analytics/retail",
    component: AnalyticsRetail,
    meta: { layout: "insurer-layout" },
  },

  {
    path: "/plan-sales",
    component: PlanSaleList,
    meta: { layout: "insurer-layout" },
  },

  {
    path: "/plan-sales/:id",
    component: PlanSaleDetails,
    meta: { layout: "insurer-layout" },
  },

  {
    path: "/organizations",
    component: OrganizationList,
    meta: { layout: "insurer-layout", adminOnly: true },
  },

  {
    path: "/stores",
    component: StoreList,
    meta: { layout: "insurer-layout" },
  },

  {
    path: "/stores/:id",
    component: StoreDetails,
    meta: { layout: "insurer-layout" },
  },

  {
    path: "/users",
    component: UserList,
    meta: { layout: "insurer-layout" },
  },

  {
    path: "/internal/users",
    component: InsurerManagerList,
    meta: { layout: "insurer-layout", adminOnly: true },
  },

  {
    path: "/internal/users/:id",
    component: InsurerManagerShow,
    meta: { layout: "insurer-layout", adminOnly: true },
  },
];

function needsHttpsRedirection() {
  return (
    (process.env.NODE_ENV === "production" || process.env.NODE_ENV === "demo" || process.env.NODE_ENV === "staging") &&
    location.protocol !== "https:"
  );
}

function redirectHttps() {
  location.replace(`https:${location.href.substring(location.protocol.length)}`);
}

function redirectToDefaultRoute(next) {
  if (store.state.auth.signedIn) {
    next("/home");
  } else {
    next("/signin");
  }
}

const routes = publicRoutes.concat(insurerRoutes);

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (needsHttpsRedirection()) {
    redirectHttps();
    return;
  }

  const publicPages = publicRoutes.map((route) => route.path);
  const authRequired = !to.matched.some((matched) => publicPages.includes(matched.path));
  const signedIn = store.state.auth.signedIn;

  if (!authRequired) {
    next();
    return;
  }

  if (!signedIn) {
    next("/signin");
  } else if (to.path === "/") {
    redirectToDefaultRoute(next);
  } else if (!to.matched.length) {
    next("/404");
  } else if (to.meta.adminOnly && !store.getters["auth/isInsurerAdmin"]) {
    next("/home");
  } else {
    next();
  }
});

export default router;
